import React from 'react';
import {
  Container,
  HBox,
  PureComponent,
  PuzzleButton,
  PuzzleCheckbox,
  VBox,
} from "puzzle";
import { DragAndDropPlaceholderProps } from "./Types";

class DragAndDropPlaceholder extends PureComponent<DragAndDropPlaceholderProps, {}> {

  /**
   * Render checkbox for extract zip option
   */
  renderExtractCheckBox = () => {
    const {
      checkboxValue,
      checkboxOnChange,
      checkboxDisabled,
      checkboxLabel
    } = this.props;

    return (
      <Container className="tp-extract-checkbox-warp">
        <PuzzleCheckbox
          label={checkboxLabel}
          value={checkboxValue}
          disabled={checkboxDisabled}
          onChange={checkboxOnChange.bind(this)}
        />
      </Container>
    );
  };

  render() {
    const {
      extractArchiveEnabled,
      dNdPlaceholderTitle,
      buttonDisabled,
      buttonOnClick,
      buttonText,
      buttonClassName = '',
      dragOverHandler,
      className = '',
      horizontal = false
    } = this.props;

    return (
      <Container className={`tp-drag-and-drop-placeholder-wrap ${className}`}>
        <div
          onDragEnter={dragOverHandler}
          className={'tp-drag-and-drop-placeholder k-hbox k-align-items-center'}
        >
          <HBox
            alignItemsCenter
            wrap
          >
            <Container
              hBox={horizontal}
              vBox={!horizontal}
              alignItemsCenter
              gap={4}
              justifyContentCenter
            >
              <span className={'tp-drag-and-drop-cloud'} />
              <VBox alignItemsStart={horizontal} alignItemsCenter={!horizontal} gap={4}>
                <Container className='tp-drag-and-drop-text-wrap'>
                  <div className={`tp-drag-and-drop-text`}>
                    {dNdPlaceholderTitle}
                  </div>
                </Container>
                <PuzzleButton
                  themeColor={'primary'}
                  fillMode={'outline'}
                  disabled={buttonDisabled}
                  onClick={buttonOnClick}
                  className={`tp-drag-and-drop-browse-button ${buttonClassName}`}
                >
                  {buttonText}
                </PuzzleButton>
                {extractArchiveEnabled && this.renderExtractCheckBox()}
              </VBox>
            </Container>
          </HBox>
        </div>
      </Container>
    );
  }
}

export default DragAndDropPlaceholder;
